(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbb-body-kit-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('lbb-body-kit-i18n-config');
  if (!config || config.dataset.initialized === 'true') return;
  let data;
  try { data = JSON.parse(config.textContent); } catch (_) { return; }
  if (!Array.isArray(data.stages) || data.stages.length !== 8
    || data.stages.some(stage => typeof stage.label !== 'string' || !stage.label)) return;
  // The translation filter escapes HTML; JSON parsing preserves those entities.
  const decodeTranslation = value => {
    if (typeof value !== 'string') return value;
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    return value.replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/g, entity => entities[entity]);
  };
  ['title', 'categoriesLabel', 'optional', 'description'].forEach(key => {
    data[key] = decodeTranslation(data[key]);
  });
  data.stages.forEach(stage => { stage.label = decodeTranslation(stage.label); });
  config.dataset.initialized = 'true';
  let root;
  let observer;
  let pending = false;
  const setText = (node, value) => {
    if (node && value && node.textContent !== value) node.textContent = value;
  };
  const setAttr = (node, key, value) => {
    if (node && value && node.getAttribute(key) !== value) node.setAttribute(key, value);
  };
  const stageOf = (node, fallback) => {
    const value = Number(node.dataset.sectionIndex ?? fallback);
    return Number.isInteger(value) && value >= 0 && value < data.stages.length ? data.stages[value] : null;
  };
  const cleanId = value => {
    const id = String(value ?? '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '');
    return /^\d+$/.test(id) ? id : '';
  };
  const productMap = new Map();
  const handleMap = new Map();
  const variantMap = new Map();
  const titleAliases = new Map();
  const normalizeTitle = value => String(value || '').replace(/\s+/g, ' ').trim();
  Object.entries(data.products || {}).forEach(([id, entry]) => {
    if (!cleanId(id) || !entry || typeof entry.title !== 'string' || !entry.title.trim()) return;
    productMap.set(cleanId(id), entry);
    if (typeof entry.handle === 'string' && entry.handle) handleMap.set(entry.handle, entry);
    Object.entries(entry.variants || {}).forEach(([variantId, title]) => {
      if (cleanId(variantId) && typeof title === 'string') variantMap.set(cleanId(variantId), { product: entry, title });
    });
  });
  const rememberTitle = (value, entry) => {
    const key = normalizeTitle(value);
    if (!key) return;
    if (!titleAliases.has(key)) titleAliases.set(key, entry);
    else if (titleAliases.get(key) !== entry) titleAliases.set(key, null);
  };
  const localizedTitle = (entry, variantId) => {
    const variant = variantMap.get(cleanId(variantId));
    if (!variant || variant.product !== entry || entry.defaultOnly || !variant.title.trim()) return entry.title;
    const compact = value => normalizeTitle(value).toLocaleLowerCase().replace(/\s/g, '');
    return compact(entry.title).includes(compact(variant.title)) ? entry.title : entry.title + ' — ' + variant.title;
  };
  const directProduct = node => {
    const holder = node?.closest('[data-product-id], [data-product-handle]');
    return holder ? productMap.get(cleanId(holder.dataset.productId)) || handleMap.get(holder.dataset.productHandle) : null;
  };
  const translateProducts = () => {
    root.querySelectorAll('.product-card').forEach(card => {
      const entry = productMap.get(cleanId(card.dataset.productId)) || handleMap.get(card.dataset.productHandle);
      if (!entry) return;
      const heading = card.querySelector('.product-title h4');
      rememberTitle(heading?.textContent, entry);
      const controls = Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'));
      const variantId = controls.length === 1 ? controls[0].dataset.variantId : null;
      const title = localizedTitle(entry, variantId);
      rememberTitle(title, entry);
      setText(heading, title);
      setAttr(card.querySelector('.product-card-image img'), 'alt', title);
    });
    root.querySelectorAll('.scpt-title h4').forEach(heading => {
      const row = heading.closest('.sc-product-item');
      const variantId = row?.dataset.variantId;
      const entry = variantMap.get(cleanId(variantId))?.product || directProduct(heading);
      if (!entry) return;
      const title = localizedTitle(entry, variantId);
      setText(heading, title);
      row?.querySelectorAll('img').forEach(image => setAttr(image, 'alt', title));
    });
    root.querySelectorAll('.product-variant-selector-header-title h3').forEach(heading => {
      const entry = directProduct(heading) || titleAliases.get(normalizeTitle(heading.textContent));
      if (!entry) return;
      setText(heading, entry.title);
      heading.closest('.product-variant-selector')?.querySelectorAll('img').forEach(image => setAttr(image, 'alt', entry.title));
    });
  };
  const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-section-index', 'data-product-id', 'data-product-handle', 'data-variant-id'] };
  const translate = () => {
    pending = false;
    if (!root?.isConnected) return;
    observer.disconnect();
    root.classList.add('lbb-body-kit-i18n');
    setText(root.querySelector('.template-top-data-header-title h2'), data.title);
    const description = root.querySelector('.template-top-data-header-description');
    if (description) {
      const signature = JSON.stringify(data.stages);
      let list = description.querySelector('.lbb-body-kit-categories');
      if (!list || list.dataset.categories !== signature) {
        list = document.createElement('span');
        list.className = 'lbb-body-kit-categories';
        list.dataset.categories = signature;
        list.setAttribute('role', 'list');
        list.setAttribute('aria-label', data.categoriesLabel);
        data.stages.forEach(stage => {
          const pill = document.createElement('span');
          pill.className = 'lbb-body-kit-category';
          pill.setAttribute('role', 'listitem');
          pill.textContent = stage.label;
          list.appendChild(pill);
        });
        description.replaceChildren(list);
      }
    }
    root.querySelectorAll('.condition-link').forEach((button, index) => {
      const stage = stageOf(button, index);
      if (!stage) return;
      setText(button, stage.label);
      setAttr(button, 'title', stage.label);
    });
    root.querySelectorAll('.individual-products-section').forEach((section, index) => {
      const stage = stageOf(section, index);
      if (!stage) return;
      setText(section.querySelector('.section-title'), stage.label);
      setText(section.querySelector('.condition-description'), data.description);
    });
    root.querySelectorAll('.bundle-step-description').forEach(node => setText(node, data.description));
    root.querySelectorAll('.bundle-step-condition').forEach(node => setText(node, data.optional));
    translateProducts();
    observer.observe(root, options);
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(translate);
  };
  const start = () => {
    root = document.getElementById('bundlesuiteContainer');
    if (!root) return false;
    observer = new MutationObserver(schedule);
    translate();
    return true;
  };
  if (!start()) {
    const boot = new MutationObserver(() => { if (start()) boot.disconnect(); });
    boot.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => boot.disconnect(), 30000);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-body-kit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-body-kit-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const translationEntities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const decodeTranslation = value => String(value).replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => translationEntities[entity.toLowerCase()]);
    const text = Object.fromEntries(Object.entries(config.dataset).map(([key, value]) => [key, key === 'returnUrl' ? value : decodeTranslation(value)]));
    const duoValues = new URLSearchParams(window.location?.search || '').getAll('lbb_duo');
    const duo = duoValues.length === 1 && duoValues[0] === '1';
    if (duo) Object.assign(text, {
      instruction: text.duoInstruction, kitTitle: text.duoKitTitle, addKit: text.duoAddKit,
      review: text.duoReview, empty: text.duoIncomplete, completeSteps: text.duoIncomplete,
      nextStep: text.duoNextCategory
    });
    const stepCount = 8;
    const processed = Array(stepCount).fill(null);
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot = null;
    let currentCart = null;
    let allowedNative = null;
    let scheduled = false;
    let expanded = false;
    let lastActive = -1;
    let feedback = '';
    let addition = null;
    let additionTimer = 0;
    let navigation = null;
    let navigationTimer = 0;
    let navigationFailed = false;
    let initializing = true;
    let initializationTimer = 0;
    let submitting = false;
    let nativeLoadingSeen = false;
    let requestSeen = false;
    let succeeded = false;
    let confirmedNativeError = false;
    let submissionToken = 0;
    const removals = new Map();
    const duoLimitedButtons = new WeakMap();
    const floatingStyles = new Map();
    let catalogueSource = null;
    let catalogue = { valid: false, products: new Map(), variantOwners: new Map() };
    const rootOf = () => document.getElementById('bundlesuiteContainer');
    const numberOf = element => /^\d+$/.test(element?.dataset.sectionIndex || '') ? Number(element.dataset.sectionIndex) : -1;
    const cleanId = value => { const id = String(value || '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, ''); return /^\d+$/.test(id) ? id : ''; };
    const readCatalogue = () => {
      const source = document.getElementById('lbb-body-kit-i18n-config')?.textContent;
      if (source === catalogueSource) return catalogue;
      catalogueSource = source;
      catalogue = { valid: false, products: new Map(), variantOwners: new Map() };
      if (!source) return catalogue;
      try {
        const entries = JSON.parse(source).products;
        if (!entries || typeof entries !== 'object' || Array.isArray(entries)) return catalogue;
        let valid = true;
        Object.entries(entries).forEach(([rawId, product]) => {
          const id = cleanId(rawId);
          if (!id || !product?.variants || typeof product.variants !== 'object' || Array.isArray(product.variants)) { valid = false; return; }
          const variants = new Set(Object.keys(product.variants).map(cleanId));
          if (!variants.size || variants.has('') || catalogue.products.has(id)) { valid = false; return; }
          catalogue.products.set(id, variants);
          variants.forEach(variantId => {
            if (catalogue.variantOwners.has(variantId) && catalogue.variantOwners.get(variantId) !== id) valid = false;
            catalogue.variantOwners.set(variantId, id);
          });
        });
        catalogue.valid = valid && catalogue.products.size > 0;
      } catch (_) { catalogue.valid = false; }
      return catalogue;
    };
    // Native tiers use requirements-not-met as styling; handleCheckout validates the minimum tier.
    const checkoutEnabled = button => button && button.matches('.side-cart-checkout-cta button') && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true';
    const cardInfo = (card, source = readCatalogue()) => {
      const id = cleanId(card?.dataset.productId);
      const variants = source.products.has(id) ? source.products.get(id) : source.variantOwners.has(id) ? new Set([id]) : new Set();
      const controls = Array.from(card?.querySelectorAll('.quantity-controls[data-variant-id]') || []);
      const valid = source.valid && variants.size > 0 && controls.every(control => !control.dataset.variantId || variants.has(cleanId(control.dataset.variantId)));
      return { id, variants, valid };
    };
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const setClass = (node, name, value) => { if (node.classList.contains(name) !== value) node.classList.toggle(name, value); };
    const setAttr = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
    const enabled = button => button && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && !button.classList.contains('requirements-not-met') && button.getAttribute('aria-disabled') !== 'true';
    const snapshot = root => {
      const source = readCatalogue();
      const sections = Array.from(root.querySelectorAll('.individual-products-section[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const tabs = Array.from(root.querySelectorAll('.condition-link[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
      const selected = new Map();
      const membership = new Map();
      const choices = Array(stepCount).fill(null);
      let valid = source.valid && sections.length === stepCount && tabs.length === stepCount;
      sections.forEach((section, index) => {
        if (numberOf(section) !== index || numberOf(tabs[index]) !== index) valid = false;
        section.querySelectorAll('.product-card[data-product-id]').forEach(card => {
          const info = cardInfo(card, source);
          if (!info.valid) valid = false;
          info.variants.forEach(id => {
            if (membership.has(id) && membership.get(id) !== index) valid = false;
            membership.set(id, index);
          });
        });
      });
      rows.forEach(row => {
        const id = cleanId(row.dataset.variantId);
        const index = membership.get(id);
        if (!id || selected.has(id) || index === undefined || index >= stepCount || choices[index] || row.querySelector('.scpt-price-quantity')?.textContent.trim() !== '1') valid = false;
        else choices[index] = id;
        selected.set(id, row);
      });
      const activeTabs = tabs.filter(tab => tab.classList.contains('active'));
      const index = activeTabs.length === 1 ? numberOf(activeTabs[0]) : -1;
      if (index < 0 || index >= stepCount) valid = false;
      return { root, sections, tabs, rows, selected, membership, choices, index, valid };
    };
    const reconcile = state => {
      processed.forEach((value, index) => {
        if (value === 'skip' && state.choices[index]) processed[index] = null;
        else if (value && value !== 'skip' && value !== state.choices[index]) processed[index] = null;
      });
    };
    const firstPending = () => { if (duo) return stepCount - 1; const index = processed.indexOf(null); return index < 0 ? stepCount - 1 : index; };
    const finished = state => state.valid && (duo ? state.rows.length === 2 : processed.every((value, index) => value && (value === 'skip' ? !state.choices[index] : value === state.choices[index])));
    const limitDuoButton = (button, limited) => {
      if (limited) {
        if (!duoLimitedButtons.has(button)) duoLimitedButtons.set(button, button.getAttribute('aria-disabled'));
        setAttr(button, 'data-lbb-body-duo-limit', 'true');
        setAttr(button, 'aria-disabled', 'true');
      } else if (duoLimitedButtons.has(button)) {
        const previous = duoLimitedButtons.get(button);
        if (previous === null) button.removeAttribute('aria-disabled');
        else setAttr(button, 'aria-disabled', previous);
        button.removeAttribute('data-lbb-body-duo-limit');
        duoLimitedButtons.delete(button);
      }
    };
    const clearAddition = () => { addition = null; clearTimeout(additionTimer); additionTimer = 0; };
    const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    const nativeClick = element => {
      allowedNative = element;
      try { element.click(); } finally { allowedNative = null; }
    };
    const clearNavigation = () => { navigation = null; clearTimeout(navigationTimer); navigationTimer = 0; };
    const focusStep = section => {
      const target = section?.querySelector('.section-title, h2, h3') || section;
      if (!target || !target.getClientRects().length) return;
      setAttr(target, 'tabindex', '-1');
      target.focus({ preventScroll: true });
      section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    const goTo = (state, index, focus = true) => {
      if (!state.valid || !Number.isInteger(index) || index < 0 || index >= stepCount || index > firstPending()) return false;
      if (index === state.index) { clearNavigation(); navigationFailed = false; if (focus) focusStep(state.sections[index]); return true; }
      const direction = index > state.index ? 1 : -1;
      const nextIndex = state.index + direction;
      if (nextIndex < 0 || nextIndex >= stepCount || (direction > 0 && nextIndex > firstPending())) return false;
      const button = Array.from(state.root.querySelectorAll(direction > 0 ? '.bundle-step-button.next-step' : '.bundle-step-button.prev-step')).find(enabled);
      if (!button) return false;
      clearNavigation();
      navigationFailed = false;
      const operation = { root: state.root, index, focus, from: state.index, expected: nextIndex };
      navigation = operation;
      expanded = false;
      nativeClick(button);
      navigationTimer = setTimeout(() => {
        if (navigation === operation) { clearNavigation(); navigationFailed = true; feedback = text.configurationError; schedule(); }
      }, 2000);
      schedule();
      return true;
    };
    const finishStep = state => {
      if (!state.valid || state.index > firstPending()) return false;
      processed[state.index] = state.choices[state.index] || 'skip';
      feedback = '';
      if (state.index < stepCount - 1) return goTo(state, state.index + 1);
      expanded = true;
      schedule();
      return true;
    };
    const removalFor = (state, id) => {
      const matches = state.rows.filter(row => row.dataset.variantId === id);
      if (matches.length !== 1) return null;
      const button = matches[0].querySelector('.remove-item-btn');
      return enabled(button) ? button : null;
    };
    const make = (tag, className, content) => {
      const node = document.createElement(tag);
      node.className = className;
      if (content) node.textContent = content;
      if (tag === 'button') node.type = 'button';
      return node;
    };
    const controlsFor = cart => {
      let controls = cart.querySelector('.lbb-body-kit-controls');
      if (controls) return controls;
      controls = make('div', 'lbb-body-kit-controls');
      controls.append(make('p', 'lbb-body-kit-offer', text.offer));
      controls.append(make('span', 'lbb-body-kit-progress'));
      const status = make('p', 'lbb-body-kit-status');
      status.id = 'lbb-body-kit-status';
      setAttr(status, 'role', 'status');
      setAttr(status, 'aria-live', 'polite');
      controls.append(status);
      const actions = make('div', 'lbb-body-kit-actions');
      for (const action of ['previous', 'next', 'submit']) {
        const button = make('button', 'lbb-body-kit-' + action);
        button.dataset.bodyKitAction = action;
        setAttr(button, 'aria-describedby', status.id);
        actions.append(button);
      }
      controls.append(actions);
      cart.append(controls);
      return controls;
    };
    const gridControlsFor = section => {
      const grid = section.querySelector('.individual-products-container');
      if (!grid) return [];
      return ['top', 'bottom'].map(position => {
        let controls = section.querySelector('.lbb-body-kit-grid-nav--' + position);
        if (!controls) {
          controls = make('div', 'lbb-body-kit-actions lbb-body-kit-grid-nav lbb-body-kit-grid-nav--' + position);
          setAttr(controls, 'role', 'group');
          for (const action of ['previous', 'next']) {
            const button = make('button', 'lbb-body-kit-' + action);
            button.dataset.bodyKitAction = action;
            button.dataset.bodyKitSectionIndex = String(numberOf(section));
            setAttr(button, 'aria-describedby', 'lbb-body-kit-status');
            controls.append(button);
          }
          if (position === 'top') grid.before(controls);
          else grid.after(controls);
        }
        return controls;
      });
    };
    const toggleFor = cart => {
      let toggle = cart.querySelector('.lbb-body-kit-toggle');
      if (toggle) return toggle;
      toggle = make('button', 'lbb-body-kit-toggle');
      toggle.dataset.bodyKitAction = 'toggle';
      const label = make('span', 'lbb-body-kit-toggle-label');
      label.append(make('strong', '', text.kitTitle), make('span', 'lbb-body-kit-toggle-action'));
      toggle.append(label, make('span', 'lbb-body-kit-toggle-total'));
      cart.prepend(toggle);
      return toggle;
    };
    const updateSpace = () => {
      const active = mobile.matches && !!currentRoot && !!currentCart;
      setClass(document.documentElement, 'lbb-body-kit-mobile', active);
      const height = active ? Math.ceil(currentCart.getBoundingClientRect().height) : 0;
      if (active && height > 0 && !expanded && currentRoot.style.getPropertyValue('--lbb-body-kit-space') !== height + 'px') currentRoot.style.setProperty('--lbb-body-kit-space', height + 'px');
      const bottom = Math.max(height, 140) + 12;
      const rules = [
        ['shopify-chat', '.activator-nudge{bottom:' + bottom + 'px!important;width:44px!important;max-width:44px!important;min-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important}.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}'],
        ['pandectes-cmp', 'button.widget.bottom.left{bottom:' + bottom + 'px!important}']
      ];
      rules.forEach(([selector, css]) => {
        const shadow = document.querySelector(selector)?.shadowRoot;
        let style = floatingStyles.get(selector);
        if (style && (!active || style.parentNode !== shadow)) { style.remove(); floatingStyles.delete(selector); style = null; }
        if (!active || !shadow) return;
        if (!style) { style = document.createElement('style'); shadow.append(style); floatingStyles.set(selector, style); }
        setText(style, '@media(max-width:767px){' + css + '}');
      });
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSpace) : null;
    const resetSubmission = message => {
      submitting = false;
      nativeLoadingSeen = false;
      requestSeen = false;
      succeeded = false;
      confirmedNativeError = false;
      submissionToken++;
      if (message) feedback = message;
      schedule();
    };
    const render = () => {
      const root = rootOf();
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart) { currentRoot = null; currentCart = null; updateSpace(); return; }
      if (currentRoot !== root) {
        processed.fill(null);
        clearAddition();
        removals.clear();
        lastActive = -1;
        expanded = false;
        feedback = '';
        clearNavigation();
        navigationFailed = false;
        resetSubmission();
        currentRoot = root;
      }
      if (currentCart !== cart) { resize?.disconnect(); currentCart = cart; resize?.observe(cart); }
      setClass(root, 'lbb-body-kit', true);
      setClass(root, 'lbb-body-kit-duo', duo);
      let back = document.getElementById('lbb-body-kit-back');
      if (!back) { back = make('a', 'lbb-body-kit-back', text.back); back.id = 'lbb-body-kit-back'; back.href = text.returnUrl; root.before(back); }
      const tabs = root.querySelector('.condition-links-container');
      if (duo) {
        let title = root.querySelector('.lbb-body-kit-duo-title');
        if (!title) { title = make('h2', 'lbb-body-kit-duo-title', text.duoTitle); if (tabs) tabs.before(title); }
        const titleHost = root.querySelector('.template-top-data-header-title');
        if (titleHost && title.parentElement !== titleHost) titleHost.append(title);
      }
      if (tabs && !root.querySelector('.lbb-body-kit-instruction')) tabs.before(make('p', 'lbb-body-kit-instruction', text.instruction));
      const state = snapshot(root);
      if (state.valid) { initializing = false; clearTimeout(initializationTimer); initializationTimer = 0; }
      else if (initializing && !initializationTimer) initializationTimer = setTimeout(() => { initializing = false; schedule(); }, 5000);
      reconcile(state);
      const nativeCheckout = root.querySelector('.side-cart-checkout-cta button');
      if (confirmedNativeError && nativeCheckout && !nativeCheckout.disabled && !nativeCheckout.classList.contains('disabled')) {
        nativeCheckout.classList.remove('loading');
        resetSubmission(text.submitError);
      }
      const loading = !!nativeCheckout?.classList.contains('loading');
      if (submitting && loading) nativeLoadingSeen = true;
      if (submitting && nativeLoadingSeen && !loading && !succeeded && !requestSeen) resetSubmission(text.submitError);
      if (state.index !== lastActive) { expanded = false; lastActive = state.index; }
      if (addition && (addition.root !== root || addition.index !== state.index)) clearAddition();
      if (addition && state.valid) {
        const accepted = state.choices[addition.index];
        if (accepted && addition.variants.has(accepted) && !addition.before.has(accepted)) {
          const index = addition.index;
          clearAddition();
          processed[index] = accepted;
          feedback = '';
          if (duo && state.rows.length >= 2) expanded = true;
          else if (index < stepCount - 1) goTo(state, index + 1);
          else expanded = true;
        }
      }
      const activeState = snapshot(root);
      reconcile(activeState);
      if (activeState.valid && activeState.index <= firstPending()) navigationFailed = false;
      if (activeState.valid && activeState.index > firstPending() && !submitting && !navigation && !navigationFailed) goTo(activeState, firstPending(), false);
      if (navigation && navigation.root === root && activeState.valid) {
        const operation = navigation;
        if (activeState.index === operation.index) {
          clearNavigation();
          if (operation.focus) focusStep(activeState.sections[operation.index]);
        } else if (activeState.index === operation.expected) {
          clearNavigation();
          if (!goTo(activeState, operation.index, operation.focus)) feedback = text.configurationError;
        } else if (activeState.index !== operation.from) {
          clearNavigation();
          navigationFailed = true;
          feedback = text.configurationError;
        }
      }
      const done = finished(activeState);
      const busy = submitting || !!addition || !!navigation || removals.size > 0;
      const controls = controlsFor(cart);
      activeState.sections.forEach(section => {
        const index = numberOf(section);
        gridControlsFor(section).forEach(group => {
          const active = index === activeState.index;
          const unavailable = !activeState.valid || !active || busy;
          setAttr(group, 'aria-label', (duo ? text.duoCategoryProgress : text.progress).replace('[current]', String(index + 1)).replace('[total]', String(stepCount)));
          const previous = group.querySelector('.lbb-body-kit-previous');
          const next = group.querySelector('.lbb-body-kit-next');
          setText(previous, text.previous);
          previous.disabled = unavailable || index === 0;
          setText(next, text.nextStep);
          next.disabled = unavailable || (index === stepCount - 1 && (duo || done));
        });
      });
      const previous = controls.querySelector('.lbb-body-kit-previous');
      const next = controls.querySelector('.lbb-body-kit-next');
      const submit = controls.querySelector('.lbb-body-kit-submit');
      setText(previous, text.previous);
      previous.disabled = !activeState.valid || activeState.index === 0 || busy;
      setText(next, duo ? text.duoNextCategory : activeState.choices[activeState.index] ? text.continue : text.skip);
      next.hidden = done || (duo && activeState.index === stepCount - 1);
      next.disabled = !activeState.valid || busy;
      setText(submit, submitting ? text.adding : text.addKit);
      submit.hidden = !duo && !done;
      submit.disabled = !done || !activeState.rows.length || busy || !checkoutEnabled(nativeCheckout);
      setText(controls.querySelector('.lbb-body-kit-progress'), duo ? text.duoProgress.replace('[count]', String(activeState.rows.length)) : text.progress.replace('[current]', String(Math.max(0, activeState.index) + 1)).replace('[total]', String(stepCount)));
      setText(controls.querySelector('.lbb-body-kit-status'), feedback || (!activeState.valid ? initializing ? text.loading : text.configurationError : duo && activeState.rows.length > 2 ? text.duoExcess : done ? activeState.rows.length ? text.review : text.empty : duo ? text.duoIncomplete : ''));
      root.setAttribute('aria-busy', submitting || (!activeState.valid && initializing) ? 'true' : 'false');
      activeState.tabs.forEach(tab => setAttr(tab, 'aria-disabled', numberOf(tab) > firstPending() || submitting ? 'true' : 'false'));
      setText(root.querySelector('.cart-head h3'), text.kitTitle);
      setText(root.querySelector('.side-cart-checkout-wrapper .subtotal-text'), text.subtotal);
      setText(root.querySelector('.side-cart-checkout-wrapper .discount-text'), text.discount);
      setText(root.querySelector('.side-cart-checkout-wrapper .total-text'), text.total);
      const toggle = toggleFor(cart);
      setAttr(toggle, 'aria-expanded', mobile.matches && expanded ? 'true' : 'false');
      const controlled = [];
      for (const [selector, suffix] of [['.side-cart-header', 'header'], ['.side-cart-product-container', 'products'], ['.side-cart-checkout-wrapper', 'totals']]) {
        const panel = cart.querySelector(selector);
        if (!panel) continue;
        if (!panel.id) panel.id = 'lbb-body-kit-panel-' + suffix;
        controlled.push(panel.id);
      }
      setAttr(toggle, 'aria-controls', controlled.join(' '));
      setText(toggle.querySelector('.lbb-body-kit-toggle-action'), expanded ? text.collapse : text.details);
      const total = root.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '';
      setText(toggle.querySelector('.lbb-body-kit-toggle-total'), activeState.rows.length && total ? text.total + ' ' + total : '');
      setClass(cart, 'lbb-body-kit-open', mobile.matches && expanded);
      removals.forEach((operation, id) => { if (!activeState.selected.has(id)) { clearTimeout(operation.timer); removals.delete(id); schedule(); } });
      root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const info = cardInfo(card);
        const variants = info.valid ? info.variants : new Set();
        const selected = [...variants].filter(id => activeState.selected.has(id));
        setClass(card, 'lbb-body-kit-selected', selected.length > 0);
        const selectedId = selected.length === 1 ? selected[0] : null;
        let remove = card.querySelector('.lbb-body-kit-remove');
        const cta = card.querySelector('.product-card-cta');
        const canRemove = selectedId && cta && removalFor(activeState, selectedId);
        if (canRemove) {
          if (!remove) { remove = make('button', 'lbb-body-kit-remove'); remove.dataset.bodyKitAction = 'remove'; }
          if (remove.parentElement !== cta) cta.append(remove);
          remove.dataset.variantId = selectedId;
          remove.disabled = submitting || !!navigation || removals.has(selectedId);
          setText(remove, text.removeChoice);
          const title = card.querySelector('.product-title h4')?.textContent.trim();
          setAttr(remove, 'aria-label', text.removeChoice + (title ? ' : ' + title : ''));
        } else remove?.remove();
        card.querySelectorAll('.add-button').forEach(button => {
          limitDuoButton(button, duo && activeState.rows.length >= 2 && !canRemove);
          if (canRemove) {
            button.setAttribute('data-lbb-body-replaced', 'true');
          } else {
            button.removeAttribute('data-lbb-body-replaced');
            if (button.dataset.stockStatus === 'out-of-stock') setText(button, text.unavailable);
            else if (button.hasAttribute('data-lbb-body-duo-limit')) setText(button, text.duoLimit);
            else if (enabled(button)) setText(button, text.choose);
            else if (button.classList.contains('disabled')) setText(button, text.otherChoice);
          }
        });
      });
      updateSpace();
    };
    const observer = new MutationObserver(() => schedule());
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'data-variant-id', 'data-section-index', 'data-stock-status'] });
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        observer.disconnect();
        try { render(); } finally { observe(); }
      });
    }
    const submitKit = state => {
      reconcile(state);
      if (submitting || addition || navigation || removals.size) return;
      if (!finished(state)) { feedback = text.completeSteps; schedule(); return; }
      if (!state.rows.length) { feedback = text.empty; schedule(); return; }
      const actions = Array.from(state.root.querySelectorAll('.side-cart-checkout-cta button')).filter(checkoutEnabled);
      if (actions.length !== 1) { feedback = text.configurationError; schedule(); return; }
      const token = ++submissionToken;
      submitting = true;
      requestSeen = false;
      succeeded = false;
      confirmedNativeError = false;
      feedback = '';
      nativeLoadingSeen = false;
      nativeClick(actions[0]);
      nativeLoadingSeen = actions[0].classList.contains('loading');
      schedule();
      setTimeout(() => {
        if (token === submissionToken && !nativeLoadingSeen && !requestSeen && !succeeded) resetSubmission(text.submitError);
      }, 1500);
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const root = rootOf();
      const popupChoice = target?.closest('.product-variant-selector-cta button');
      if (!root || !target || (!root.contains(target) && !popupChoice)) return;
      if (allowedNative && (target === allowedNative || allowedNative.contains(target))) return;
      const state = snapshot(root);
      reconcile(state);
      const custom = target.closest('[data-body-kit-action]');
      if (custom) {
        stop(event);
        const action = custom.dataset.bodyKitAction;
        if (action === 'toggle') { expanded = !expanded; schedule(); return; }
        if (custom.disabled || submitting || navigation) return;
        if (custom.dataset.bodyKitSectionIndex !== undefined && Number(custom.dataset.bodyKitSectionIndex) !== state.index) return;
        if (action === 'submit') { submitKit(state); return; }
        if (action === 'previous') { clearAddition(); feedback = ''; goTo(state, Math.min(state.index - 1, firstPending())); return; }
        if (action === 'next') {
          if (addition || removals.size) return;
          const completed = finishStep(state);
          if (completed && state.index === stepCount - 1 && custom.dataset.bodyKitSectionIndex !== undefined) {
            requestAnimationFrame(() => {
              const summary = currentCart?.querySelector('.lbb-body-kit-controls');
              if (summary) { setAttr(summary, 'tabindex', '-1'); summary.focus({ preventScroll: true }); summary.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
            });
          }
          return;
        }
        if (action === 'remove') {
          clearAddition();
          const id = custom.dataset.variantId;
          const card = custom.closest('.product-card[data-product-id]');
          const info = cardInfo(card);
          const belongs = info.valid && info.variants.has(id);
          const button = belongs && removalFor(state, id);
          if (!button || removals.has(id)) return;
          const operation = { timer: 0 };
          removals.set(id, operation);
          custom.disabled = true;
          nativeClick(button);
          operation.timer = setTimeout(() => { if (removals.get(id) === operation) { removals.delete(id); schedule(); } }, 2000);
          schedule();
        }
        return;
      }
      const nativeFinal = target.closest('.side-cart-checkout-cta button');
      const next = target.closest('.bundle-step-button.next-step');
      const previous = target.closest('.bundle-step-button.prev-step');
      const tab = target.closest('.condition-link[data-section-index]');
      if (nativeFinal || next || previous || tab) {
        stop(event);
        if (submitting || navigation) return;
        if (nativeFinal) { submitKit(state); return; }
        if (next) { if (!addition && !removals.size) finishStep(state); return; }
        clearAddition();
        const index = previous ? Math.min(state.index - 1, firstPending()) : numberOf(tab);
        if (!goTo(state, index)) { feedback = text.completeSteps; schedule(); }
        return;
      }
      const remove = target.closest('.remove-item-btn');
      if (remove) { if (submitting || navigation) stop(event); clearAddition(); schedule(); return; }
      const add = popupChoice || target.closest('.add-button');
      if (!add) return;
      if (duo && state.rows.length >= 2) { stop(event); feedback = state.rows.length > 2 ? text.duoExcess : text.duoReview; schedule(); return; }
      if (submitting || navigation || (addition && !popupChoice) || removals.size || !state.valid || !enabled(add)) { stop(event); return; }
      const activeCards = popupChoice ? Array.from(root.querySelectorAll('.product-card[data-product-id][data-active="true"]')) : [];
      const card = popupChoice ? activeCards.length === 1 ? activeCards[0] : null : add.closest('.product-card[data-product-id]');
      const section = card?.closest('.individual-products-section[data-section-index]');
      const index = numberOf(section);
      const info = cardInfo(card);
      const exactVariant = cleanId(add.closest('.quantity-controls[data-variant-id]')?.dataset.variantId);
      const variants = exactVariant ? new Set([exactVariant]) : info.variants;
      if (!card || !info.valid || index !== state.index || index > firstPending() || state.choices[index] || !variants.size || [...variants].some(id => !info.variants.has(id) || state.selected.has(id))) { stop(event); return; }
      feedback = '';
      clearAddition();
      addition = { root, index, variants, before: new Set(state.selected.keys()) };
      additionTimer = setTimeout(() => { clearAddition(); schedule(); }, 8000);
      schedule();
    }, true);
    document.addEventListener('change', event => {
      if (!addition) return;
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest('.product-card[data-product-id]');
      if (card && ![...cardInfo(card).variants].some(id => addition.variants.has(id))) clearAddition();
    }, true);
    document.addEventListener('lbb:body-kit-cart-request', event => {
      const state = event.detail?.state;
      if (state === 'pending') { submitting = true; requestSeen = true; clearAddition(); }
      else if (state === 'success') { submitting = true; requestSeen = true; succeeded = true; }
      else if (state === 'error') { confirmedNativeError = true; feedback = text.submitError; }
      schedule();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) { clearAddition(); resetSubmission(); } });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && expanded) { expanded = false; schedule(); currentCart?.querySelector('.lbb-body-kit-toggle')?.focus(); } });
    mobile.addEventListener('change', () => { expanded = false; schedule(); });
    observe();
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-formula-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-formula-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    const knownChoiceLabels = new Set([
      'Choix effectué', 'Choice made', 'Selection made', 'Selected',
      text.selected, text.otherChoice
    ]);
    const unavailableLabel = /indisponible|rupture|épuisé|sold\s*out|out\s*of\s*stock|unavailable/i;
    let pending = false;
    const removingVariants = new Map();
    const removalFor = (root, variantId) => {
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'))
        .filter(row => row.dataset.variantId === variantId);
      if (rows.length !== 1) return null;
      const action = rows[0].querySelector('.remove-item-btn');
      return action && !action.disabled && !action.classList.contains('disabled')
        && action.getAttribute('aria-disabled') !== 'true' ? action : null;
    };
    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };
    const applyPresentation = () => {
      const root = document.getElementById('bundlesuiteContainer');
      if (!root) return;
      root.classList.add('lbb-kit-formula-ui');
      let back = document.getElementById('lbb-kit-formula-ui-back');
      if (!back) {
        back = document.createElement('a');
        back.id = 'lbb-kit-formula-ui-back';
        back.className = 'lbb-kit-formula-ui-back';
        back.href = text.returnUrl;
        back.textContent = text.back;
        root.before(back);
      }
      const stepLinks = root.querySelector('.condition-links-container');
      if (stepLinks && !root.querySelector('.lbb-kit-formula-ui-step-note')) {
        const stepNote = document.createElement('p');
        stepNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-step-note';
        stepNote.textContent = text.autoStepNote;
        stepLinks.before(stepNote);
      }
      const discountAnchor = stepLinks || root.querySelector('.individual-products-section[data-section-index]');
      if (text.discountNote && discountAnchor && !root.querySelector('.lbb-kit-formula-ui-discount-note')) {
        const discountNote = document.createElement('p');
        discountNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-discount-note';
        discountNote.textContent = text.discountNote;
        discountAnchor.before(discountNote);
      }
      setText(root.querySelector('.side-cart-checkout-wrapper .subtotal-text'), text.subtotalLabel);
      setText(root.querySelector('.side-cart-checkout-wrapper .discount-text'), text.discountLabel);
      setText(root.querySelector('.side-cart-checkout-wrapper .total-text'), text.totalLabel);
      const checkout = root.querySelector('.side-cart-checkout-wrapper');
      if (text.country === 'FR' && text.currency === 'EUR' && text.shippingNote
        && checkout && !checkout.querySelector('.lbb-kit-formula-ui-shipping-note')) {
        const shippingNote = document.createElement('p');
        shippingNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-shipping-note';
        shippingNote.textContent = text.shippingNote;
        checkout.append(shippingNote);
      }
      setText(root.querySelector('.cart-head h3'), text.title);
      const cartHead = root.querySelector('.cart-head');
      if (cartHead && !cartHead.querySelector('.lbb-kit-formula-ui-note')) {
        const note = document.createElement('p');
        note.className = 'lbb-kit-formula-ui-note';
        note.textContent = text.duoNote;
        cartHead.append(note);
      }
      const count = root.querySelector('.cart-totoal-added-products p');
      const countNumber = count && count.querySelector('.added-products-count');
      if (countNumber) {
        let suffix = null;
        for (const child of count.childNodes) {
          if (child.nodeType === Node.TEXT_NODE && child.previousSibling === countNumber) {
            suffix = child;
            break;
          }
        }
        if (suffix && suffix.textContent !== ' ' + text.count) suffix.textContent = ' ' + text.count;
      }
      const selectedVariants = new Set(
        Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'), row => row.dataset.variantId).filter(Boolean)
      );
      const removedChoices = [];
      removingVariants.forEach((operation, id) => {
        if (!selectedVariants.has(id)) {
          removingVariants.delete(id);
          removedChoices.push(operation);
        }
      });
      root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const variants = Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'), control => control.dataset.variantId);
        const selected = variants.some(id => selectedVariants.has(id));
        card.classList.toggle('lbb-kit-formula-ui-selected', selected);
        card.querySelectorAll('.add-button.disabled').forEach(button => {
          const label = button.textContent.trim();
          if (unavailableLabel.test(label) || !knownChoiceLabels.has(label)) return;
          const controls = button.closest('.quantity-controls[data-variant-id]');
          const buttonSelected = controls ? selectedVariants.has(controls.dataset.variantId) : selected;
          setText(button, buttonSelected ? text.selected : text.otherChoice);
        });
        card.querySelectorAll('.add-button').forEach(button => {
          const controls = button.closest('.quantity-controls[data-variant-id]');
          const candidates = controls ? [controls.dataset.variantId] : variants;
          const selectedIds = [...new Set(candidates.filter(id => selectedVariants.has(id)))];
          const variantId = selectedIds.length === 1 ? selectedIds[0] : null;
          let remove = button.nextElementSibling;
          if (!remove?.classList.contains('lbb-kit-remove-choice')) remove = null;
          if (!variantId || !removalFor(root, variantId)) {
            button.removeAttribute('data-lbb-remove-replaced');
            remove?.remove();
            return;
          }
          button.setAttribute('data-lbb-remove-replaced', 'true');
          if (!remove) {
            remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'lbb-kit-remove-choice';
            button.after(remove);
          }
          remove.dataset.variantId = variantId;
          remove.disabled = removingVariants.has(variantId);
          setText(remove, text.removeChoice);
          const title = card.querySelector('.product-title h4')?.textContent.trim();
          remove.setAttribute('aria-label', text.removeChoice + (title ? ' : ' + title : ''));
        });
      });
      removedChoices.forEach(operation => {
        if (!operation.hadFocus || (document.activeElement !== document.body
          && document.activeElement !== operation.button)) return;
        const card = Array.from(root.querySelectorAll('.product-card[data-product-id]'))
          .find(candidate => candidate.dataset.productId === operation.productId
            && candidate.closest('.individual-products-section')?.dataset.sectionIndex === operation.sectionIndex);
        const choose = card?.querySelector('.add-button:not(:disabled):not(.disabled):not([aria-disabled="true"])');
        if (choose?.getClientRects().length) choose.focus({ preventScroll: true });
      });
    };
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        observer.disconnect();
        applyPresentation();
        observe();
      });
    });
    const observe = () => observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-variant-id', 'disabled']
    });
    applyPresentation();
    observe();

    let selectionJob = null;
    let selectionTimer = 0;
    let selectionFrame = 0;
    let ownNavigation = false;
    let cartSubmission = false;
    let submissionStarted = false;
    let submissionAttempt = 0;
    const expectedChoices = Number(text.expectedChoices);
    const getRoot = () => document.getElementById('bundlesuiteContainer');
    const sectionsOf = root => Array.from(root.querySelectorAll('.individual-products-section[data-section-index]'));
    const indexOf = element => {
      const value = element?.dataset.sectionIndex;
      return /^\d+$/.test(value || '') ? Number(value) : -1;
    };
    const activeIndex = root => {
      const active = root.querySelector('.condition-link.active[data-section-index]');
      if (active) return indexOf(active);
      const sections = sectionsOf(root);
      return sections.length === 1 && sections[0].getClientRects().length ? indexOf(sections[0]) : -1;
    };
    const sectionAt = (root, index) => sectionsOf(root).find(section => indexOf(section) === index);
    const selectedRows = root => Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
    const readyButton = button => button && button.getClientRects().length
      && !button.disabled && !button.classList.contains('disabled')
      && !button.classList.contains('loading')
      && !button.classList.contains('requirements-not-met')
      && button.getAttribute('aria-disabled') !== 'true';
    const completeSelection = root => {
      if (!Number.isInteger(expectedChoices) || expectedChoices < 1 || expectedChoices > 4) return false;
      const sections = sectionsOf(root);
      const rows = selectedRows(root);
      if (sections.length !== expectedChoices || rows.length !== expectedChoices) return false;
      const selected = new Set(rows.map(row => row.dataset.variantId).filter(Boolean));
      if (selected.size !== expectedChoices
        || rows.some(row => row.querySelector('.scpt-price-quantity')?.textContent.trim() !== '1')) return false;
      const covered = new Set();
      for (let index = 0; index < expectedChoices; index++) {
        const matches = sections.filter(section => indexOf(section) === index);
        if (matches.length !== 1) return false;
        const choices = new Set(Array.from(matches[0].querySelectorAll('.quantity-controls[data-variant-id]'),
          control => control.dataset.variantId).filter(id => selected.has(id)));
        if (choices.size !== 1) return false;
        const id = choices.values().next().value;
        if (covered.has(id)) return false;
        covered.add(id);
      }
      return covered.size === expectedChoices;
    };
    const finalAction = root => {
      if (root.querySelector('.side-cart-checkout-cta button.loading')) return null;
      const next = Array.from(root.querySelectorAll('.bundle-step-button.next-step')).filter(readyButton);
      if (next.length === 1) return next[0];
      const cart = Array.from(root.querySelectorAll('.side-cart-checkout-cta button')).filter(readyButton);
      return cart.length === 1 ? cart[0] : null;
    };
    const lockCartSubmission = () => {
      const attempt = ++submissionAttempt;
      cartSubmission = true;
      submissionStarted = false;
      // A native validation failure may stop before a request is made. Never retry it automatically.
      setTimeout(() => {
        if (attempt === submissionAttempt && !submissionStarted) cartSubmission = false;
      }, 1500);
    };
    document.addEventListener('lbb:kit-cart-request', event => {
      if (event.detail?.state === 'pending') {
        cartSubmission = true;
        submissionStarted = true;
        clearSelectionJob();
      } else if (event.detail?.state === 'error') {
        cartSubmission = false;
        submissionStarted = false;
        clearSelectionJob();
      }
      // Success stays locked while BundleSuite opens the cart in the selected language.
    });
    const clearSelectionJob = () => {
      selectionJob = null;
      clearTimeout(selectionTimer);
      selectionTimer = 0;
    };
    document.defaultView?.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      submissionAttempt++;
      cartSubmission = false;
      submissionStarted = false;
      clearSelectionJob();
    });
    const focusStep = target => {
      if (!target || !target.getClientRects().length) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.classList.add('lbb-kit-formula-ui-step-focus');
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        block: 'start',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    const scheduleSelectionCheck = () => {
      if (!selectionJob || selectionFrame) return;
      selectionFrame = requestAnimationFrame(() => {
        selectionFrame = 0;
        checkSelection();
      });
    };
    function checkSelection() {
      const job = selectionJob;
      if (!job) return;
      const root = getRoot();
      if (!root || root !== job.root) return clearSelectionJob();
      const currentIndex = activeIndex(root);
      if (job.phase === 'navigation') {
        if (currentIndex !== job.index && currentIndex !== job.nextIndex) return clearSelectionJob();
        if (currentIndex !== job.nextIndex) return;
        const nextSection = sectionAt(root, job.nextIndex);
        if (!nextSection || !nextSection.getClientRects().length) return;
        clearSelectionJob();
        focusStep(nextSection.querySelector('.section-title, h2, h3') || nextSection);
        return;
      }
      if (currentIndex !== job.index) return clearSelectionJob();
      const section = sectionAt(root, job.index);
      const card = section && Array.from(section.querySelectorAll('.product-card[data-product-id]'))
        .find(candidate => candidate.dataset.productId === job.productId);
      if (!card) return;
      const variants = new Set(Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'),
        control => control.dataset.variantId).filter(Boolean));
      const acceptedRow = selectedRows(root).find(row => variants.has(row.dataset.variantId)
        && !job.before.has(row.dataset.variantId)
        && row.querySelector('.scpt-price-quantity')?.textContent.trim() === '1');
      if (!acceptedRow) return;
      if (job.index === expectedChoices - 1) {
        if (window.LBBKitEdit?.active) { clearSelectionJob(); return; }
        if (cartSubmission || !completeSelection(root)) return;
        const action = finalAction(root);
        if (!action) return;
        clearSelectionJob();
        lockCartSubmission();
        ownNavigation = true;
        try {
          action.click();
        } finally {
          ownNavigation = false;
        }
        return;
      }
      const nextSection = sectionAt(root, job.index + 1);
      if (!nextSection) {
        clearSelectionJob();
        focusStep(root.querySelector('.cart-head h3'));
        return;
      }
      const next = Array.from(root.querySelectorAll('.bundle-step-button.next-step'))
        .find(button => button.getClientRects().length && !button.disabled
          && button.getAttribute('aria-disabled') !== 'true');
      if (!next) return;
      job.phase = 'navigation';
      job.nextIndex = job.index + 1;
      ownNavigation = true;
      try {
        next.click();
      } finally {
        ownNavigation = false;
      }
      scheduleSelectionCheck();
    }
    document.addEventListener('click', event => {
      if (ownNavigation || !event.isTrusted) return;
      clearSelectionJob();
      const root = getRoot();
      const target = event.target instanceof Element ? event.target : null;
      if (!root || !target || !root.contains(target)) return;
      const checkout = target.closest('.side-cart-checkout-cta button');
      const lastNext = target.closest('.bundle-step-button.next-step');
      if (checkout || (lastNext && activeIndex(root) === expectedChoices - 1)) {
        if (cartSubmission || root.querySelector('.side-cart-checkout-cta button.loading')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        } else if (readyButton(checkout || lastNext) && completeSelection(root)) {
          lockCartSubmission();
        }
        return;
      }
      if (cartSubmission) return;
      const remove = target.closest('.lbb-kit-remove-choice');
      if (remove) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const variantId = remove.dataset.variantId;
        const card = remove.closest('.product-card[data-product-id]');
        const matchesCard = card && Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'))
          .some(control => control.dataset.variantId === variantId);
        const nativeRemove = matchesCard && removalFor(root, variantId);
        if (!nativeRemove || removingVariants.has(variantId)) return;
        const operation = {
          button: remove,
          hadFocus: document.activeElement === remove,
          productId: card.dataset.productId,
          sectionIndex: card.closest('.individual-products-section')?.dataset.sectionIndex
        };
        removingVariants.set(variantId, operation);
        remove.disabled = true;
        nativeRemove.click();
        setTimeout(() => {
          if (removingVariants.get(variantId) !== operation) return;
          removingVariants.delete(variantId);
          applyPresentation();
        }, 2000);
        return;
      }
      const add = target.closest('.add-button');
      if (!add || add.disabled || add.classList.contains('disabled')
        || add.getAttribute('aria-disabled') === 'true'
        || unavailableLabel.test(add.textContent)) return;
      const card = add.closest('.product-card[data-product-id]');
      const section = card?.closest('.individual-products-section[data-section-index]');
      const index = activeIndex(root);
      if (!card || !section || index < 0 || indexOf(section) !== index
        || !section.getClientRects().length || !card.dataset.productId) return;
      selectionJob = {
        phase: 'addition', root, index, productId: card.dataset.productId,
        before: new Set(selectedRows(root).map(row => row.dataset.variantId).filter(Boolean))
      };
      selectionTimer = setTimeout(clearSelectionJob, 8000);
      scheduleSelectionCheck();
    }, true);
    document.addEventListener('change', event => {
      if (event.isTrusted && selectionJob) clearSelectionJob();
    }, true);
    new MutationObserver(scheduleSelectionCheck).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'data-variant-id']
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
      const config = document.getElementById('lbb-kit-native-labels');
      if (!config || !document.getElementById('lbb-kit-formula-ui-config')) return;
      const data = JSON.parse(config.textContent), labels = data.labels;
      const stages = ['duo', 'mask', 'leavein', 'fragrance'];
      const setText = (node, value) => { if (node && value && node.textContent !== value) node.textContent = value; };
      const setAttr = (node, key, value) => { if (node && value && node.getAttribute(key) !== value) node.setAttribute(key, value); };
      let root, observer, queued = false;
      const options = {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','disabled','data-product-id']};
      const translate = () => {
        queued = false;
        if (!root?.isConnected) return;
        observer.disconnect();
        setText(root.querySelector('.template-top-data-header-title h2'), data.title);
        const description = root.querySelector('.template-top-data-header-description');
        if (description && Array.isArray(data.contents)) {
          const signature = JSON.stringify(data.contents);
          let contents = description.querySelector('.lbb-kit-contents');
          if (!contents || contents.dataset.contents !== signature) {
            contents = document.createElement('span');
            contents.className = 'lbb-kit-contents';
            contents.dataset.contents = signature;
            contents.setAttribute('role', 'list');
            contents.setAttribute('aria-label', data.contentsLabel);
            data.contents.forEach(label => {
              const pill = document.createElement('span');
              pill.className = 'lbb-kit-contents-pill';
              pill.setAttribute('role', 'listitem');
              pill.textContent = label;
              contents.appendChild(pill);
            });
            description.replaceChildren(contents);
          }
        }
        const sections = Array.from(root.querySelectorAll('.individual-products-section'));
        const stageCount = root.querySelectorAll('.condition-link').length || sections.length;
        const active = root.querySelector('.condition-link.active');
        const activeIndex = Number(active?.dataset.sectionIndex || 0);
        sections.forEach((section, index) => {
          if (Number(section.dataset.sectionIndex ?? index) !== activeIndex) return;
          section.querySelectorAll('.product-card-image img').forEach(image => {
            setAttr(image, 'loading', 'eager');
            setAttr(image, 'decoding', 'async');
          });
        });
        if (data.cresposImage) root.querySelectorAll('.product-card[data-product-id="56403367297289"], .product-card[data-product-handle="masque-pour-cheveux-afro-1kg-crespo-divino-skala"]').forEach(card => {
          const slot = card.querySelector('.product-card-image');
          if (!slot) return;
          let image = slot.querySelector('img');
          if (!image) {
            image = document.createElement('img');
            image.src = data.cresposImage;
            image.alt = card.querySelector('.product-title h4')?.textContent || '';
            slot.appendChild(image);
          }
          if (!image.dataset.lbbImageFallback) {
            image.dataset.lbbImageFallback = 'ready';
            const recover = () => {
              if (image.dataset.lbbImageFallback === 'used') return;
              image.dataset.lbbImageFallback = 'used';
              image.removeAttribute('srcset');
              image.src = data.cresposImage;
            };
            image.addEventListener('error', recover, {once:true});
            if (image.complete && image.naturalWidth === 0) recover();
          }
        });
        root.querySelectorAll('.condition-link').forEach((button, index) => {
          const stage = stages[Number(button.dataset.sectionIndex ?? index)];
          setText(button, labels['step_' + stage]);
          setAttr(button, 'title', labels['step_' + stage]);
        });
        sections.forEach((section, index) => {
          const stage = stages[Number(section.dataset.sectionIndex ?? index)];
          setText(section.querySelector('.section-title'), labels['step_' + stage]);
          setText(section.querySelector('.condition-description'), labels['desc_' + stage]);
        });
        root.querySelectorAll('.bundle-step-description').forEach(node => setText(node, labels['desc_' + stages[activeIndex]]));
        root.querySelectorAll('.bundle-step-condition').forEach(node => setText(node, labels.one_choice));
        root.querySelectorAll('.prev-step').forEach(node => setText(node, labels.previous));
        const cartAction = window.LBBKitEdit?.active ? window.LBBKitEdit.saveLabel : labels.add_to_cart;
        root.querySelectorAll('.next-step').forEach(node => setText(node, stageCount > 0 && activeIndex >= stageCount - 1 ? cartAction : labels.next));
        root.querySelectorAll('.side-cart-checkout-cta button').forEach(node => {setText(node, cartAction); setAttr(node,'title',cartAction);});
        root.querySelectorAll('.add-button:not(:disabled):not(.disabled):not([aria-disabled="true"]), .product-variant-selector-cta button:not(:disabled):not(.disabled):not([aria-disabled="true"])').forEach(node => setText(node,labels.choose));
        root.querySelectorAll('.add-button').forEach(node => {
          if (/^(indisponible|rupture de stock|épuisé|sold out|out of stock|unavailable)$/i.test(node.textContent.trim())) setText(node,labels.unavailable);
        });
        root.querySelectorAll('.remove-item-btn').forEach(node => setAttr(node,'aria-label',labels.remove));
        root.querySelectorAll('.close-variant-selector button').forEach(node => setAttr(node,'aria-label',labels.close));
        root.querySelectorAll('.quantity-input').forEach(node => setAttr(node,'aria-label',labels.quantity));
        root.querySelectorAll('.quantity-btn.plus').forEach(node => setAttr(node,'aria-label',labels.increase));
        root.querySelectorAll('.quantity-btn.minus').forEach(node => setAttr(node,'aria-label',labels.decrease));
        root.querySelectorAll('*').forEach(node => {
          if (node.children.length) return;
          const value=node.textContent.trim();
          if (/^(Cart empty|Votre routine commence ici)$/i.test(value)) setText(node,labels.empty);
          if (/^Loading products(?:\.{3}|…)?$/i.test(value)) setText(node,labels.loading);
        });
        const titleLookup = new Map(Object.values(data.titles).map(entry => [entry.original,entry.title]));
        root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
          const entry = data.titles[card.dataset.productId] || Object.values(data.titles).find(item => item.handle === card.dataset.productHandle);
          if (!entry) return;
          const heading=card.querySelector('.product-title h4');
          const current=heading?.textContent.trim() || '';
          const format=current.match(/\s-\s(\d+(?:[.,]\d+)?\s*(?:kg|g|ml|l))$/i)?.[1];
          const title=entry.title+(format&&!entry.title.endsWith(format)?' - '+format:'');
          titleLookup.set(current,title);
          setText(heading,title);
          setAttr(card.querySelector('.product-card-image img'),'alt',title);
        });
        root.querySelectorAll('.scpt-title h4, .product-variant-selector-header-title h3').forEach(node => setText(node,titleLookup.get(node.textContent.trim())));
        observer.observe(root,options);
      };
      const schedule = () => { if (!queued) { queued=true; requestAnimationFrame(translate); } };
      const start = () => {
        root=document.getElementById('bundlesuiteContainer');
        if (!root) return false;
        observer=new MutationObserver(schedule); translate(); return true;
      };
      if (!start()) {
        const boot = new MutationObserver(() => {if(start())boot.disconnect();});
        boot.observe(document.body,{childList:true,subtree:true});
        setTimeout(()=>boot.disconnect(),30000);
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-mobile-config');
    if (!config || !document.getElementById('lbb-kit-formula-ui-config') || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot = null;
    let currentCart = null;
    let previousStep = null;
    let expanded = false;
    let scheduled = false;
    let compactHeight = 132;
    let panelHeight = 132;
    const floatingStyles = new Map();
    const writeText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };
    const writeClass = (element, name, value) => {
      if (element.classList.contains(name) !== value) element.classList.toggle(name, value);
    };
    const writeAttribute = (element, name, value) => {
      if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    };
    const syncFloatingControls = () => {
      const enabled = mobile.matches && !!currentCart && !!currentRoot?.classList.contains('lbb-kit-mobile-ready');
      const bottom = panelHeight + 12;
      const rules = [
        ['shopify-chat', '.activator-nudge{bottom:' + bottom + 'px!important;width:48px!important;max-width:48px!important;min-width:48px!important;height:48px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{box-sizing:border-box!important;width:48px!important;height:48px!important;min-width:48px!important;min-height:48px!important;padding:0!important;gap:0!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator-nudge>button.activator[part="activator"]>.activator__label{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}'],
        ['pandectes-cmp', 'button.widget.bottom.left{bottom:' + bottom + 'px!important}']
      ];
      let ready = true;
      for (const [selector, css] of rules) {
        const shadow = document.querySelector(selector)?.shadowRoot;
        let style = floatingStyles.get(selector);
        if (style && (!enabled || style.parentNode !== shadow)) {
          style.remove();
          floatingStyles.delete(selector);
          style = null;
        }
        if (!enabled) continue;
        if (!shadow) {
          ready = false;
          continue;
        }
        if (!style) {
          style = document.createElement('style');
          style.id = 'lbb-kit-mobile-floating';
          shadow.append(style);
          floatingStyles.set(selector, style);
        }
        writeText(style, '@media screen and (max-width:767px){' + css + '}');
      }
      return enabled && ready;
    };
    const updateSpace = () => {
      if (!currentRoot || !currentCart || !mobile.matches) {
        syncFloatingControls();
        return;
      }
      const height = Math.ceil(currentCart.getBoundingClientRect().height);
      if (height > 0) {
        panelHeight = height;
        if (!expanded) compactHeight = height;
      }
      const space = compactHeight + 'px';
      if (height > 0 && currentRoot.style.getPropertyValue('--lbb-kit-mobile-space') !== space) {
        currentRoot.style.setProperty('--lbb-kit-mobile-space', space);
      }
      syncFloatingControls();
    };
    const resize = new ResizeObserver(updateSpace);
    const makeToggle = cart => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lbb-kit-mobile-toggle';
      const title = document.createElement('span');
      title.className = 'lbb-kit-mobile-toggle-title';
      const label = document.createElement('strong');
      label.textContent = text.summaryLabel;
      const action = document.createElement('span');
      action.className = 'lbb-kit-mobile-toggle-action';
      title.append(label, action);
      const values = document.createElement('span');
      values.className = 'lbb-kit-mobile-toggle-values';
      const selection = document.createElement('span');
      selection.className = 'lbb-kit-mobile-toggle-selection';
      const total = document.createElement('span');
      total.className = 'lbb-kit-mobile-toggle-total';
      const saving = document.createElement('span');
      saving.className = 'lbb-kit-mobile-toggle-saving';
      values.append(selection, total, saving);
      button.append(title, values);
      cart.prepend(button);
      return button;
    };
    const observe = () => {
      const target = currentRoot || document.body;
      observer.observe(target, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'data-section-index']
      });
    };
    const render = () => {
      observer.disconnect();
      const root = document.getElementById('bundlesuiteContainer');
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart || !root.classList.contains('lbb-kit-formula-ui')) {
        writeClass(document.documentElement, 'lbb-kit-mobile-active', false);
        currentCart = null;
        currentRoot = root;
        syncFloatingControls();
        observe();
        return;
      }
      if (currentRoot !== root || currentCart !== cart) {
        const sameRoot = currentRoot === root;
        resize.disconnect();
        currentRoot = root;
        currentCart = cart;
        if (!sameRoot) {
          previousStep = null;
          expanded = false;
        }
        resize.observe(cart);
      }
      const step = root.querySelector('.condition-link.active[data-section-index]')?.dataset.sectionIndex ?? null;
      if (previousStep !== null && step !== previousStep) expanded = false;
      if (!mobile.matches) expanded = false;
      previousStep = step;
      writeClass(document.documentElement, 'lbb-kit-mobile-active', mobile.matches);
      writeClass(root, 'lbb-kit-mobile-ready', mobile.matches);
      writeClass(cart, 'lbb-kit-mobile-cart', mobile.matches);
      writeClass(cart, 'lbb-kit-mobile-open', mobile.matches && expanded);
      const next = cart.querySelector('.bundle-step-buttons .next-step');
      const nextVisible = !!next && next.getClientRects().length > 0 && getComputedStyle(next).visibility !== 'hidden';
      writeClass(cart, 'lbb-kit-mobile-step-action', mobile.matches && nextVisible);
      let toggle = cart.querySelector(':scope > .lbb-kit-mobile-toggle');
      if (!toggle) toggle = makeToggle(cart);
      writeAttribute(toggle, 'aria-expanded', expanded ? 'true' : 'false');
      const controlled = [];
      for (const [selector, suffix] of [
        ['.side-cart-header', 'header'],
        ['.side-cart-product-container', 'products'],
        ['.lbb-kit-savings', 'savings'],
        ['.side-cart-checkout-wrapper', 'totals']
      ]) {
        const node = cart.querySelector(selector);
        if (!node) continue;
        if (!node.id) node.id = 'lbb-kit-mobile-' + suffix;
        controlled.push(node.id);
      }
      writeAttribute(toggle, 'aria-controls', controlled.join(' '));
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-action'), expanded ? text.hideDetails : text.showDetails);
      const count = cart.querySelector('.added-products-count')?.textContent.trim() || '0';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-selection'), count + ' ' + text.selectionLabel);
      const total = cart.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-total'), total && count !== '0' ? text.totalLabel + ' ' + total : '');
      const saving = cart.querySelector('.lbb-kit-savings.is-positive [data-savings-state]')?.textContent.trim() || '';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-saving'), saving);
      if (!mobile.matches) {
        if (root.style.getPropertyValue('--lbb-kit-mobile-space')) root.style.removeProperty('--lbb-kit-mobile-space');
      }
      observe();
      updateSpace();
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        render();
      });
    };
    const observer = new MutationObserver(schedule);
    mobile.addEventListener('change', schedule);
    document.addEventListener('click', event => {
      if (!mobile.matches) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const toggle = target?.closest('.lbb-kit-mobile-toggle');
      if (!toggle) return;
      const root = document.getElementById('bundlesuiteContainer');
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart || !cart.contains(toggle)) return;
      if (root !== currentRoot || cart !== currentCart) render();
      if (!currentCart?.contains(toggle)) return;
      event.preventDefault();
      event.stopPropagation();
      expanded = !expanded;
      render();
      if (!expanded && currentCart) currentCart.scrollTop = 0;
    }, true);
    new MutationObserver(records => {
      const appAdded = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('shopify-chat, pandectes-cmp') || node.querySelector('shopify-chat, pandectes-cmp'))
      ));
      if (appAdded) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    let floatingAttempts = 0;
    const waitForFloatingControls = () => {
      if (!mobile.matches) return;
      floatingAttempts += 1;
      if (!syncFloatingControls() && floatingAttempts < 15) setTimeout(waitForFloatingControls, 1000);
    };
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !mobile.matches || !expanded) return;
      const focused = document.activeElement;
      const returnFocus = currentCart?.contains(focused);
      expanded = false;
      render();
      if (returnFocus) currentCart.querySelector('.lbb-kit-mobile-toggle')?.focus();
    });
    render();
    waitForFloatingControls();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-savings"] && !Shopify.designMode) return;
  try {
    (() => {
    const isKnownComplementCard = (card, variantId, variants, handles) => {
      const expectedProductId = variants[variantId];
      if (!card || !expectedProductId) return false;
      const actualId = card.dataset.productId;
      const handle = card.dataset.productHandle;
      const expectedHandle = handles[expectedProductId];
      if (actualId === expectedProductId) return !handle || handle === expectedHandle;
      return actualId === variantId && Boolean(expectedHandle) && handle === expectedHandle;
    };
    const parseEurMoney = value => {
      if (typeof value !== 'string') return null;
      const compact = value.trim().replace(/[\s\u00a0\u202f]/g, '');
      if (!/^(?:€|EUR)?\d[\d.,]*(?:€|EUR)?$/i.test(compact)) return null;
      const currencies = compact.match(/€|EUR/gi) || [];
      if (currencies.length !== 1) return null;
      const amount = compact.replace(/€|EUR/gi, '');
      let normalized;
      if (/^\d+(?:[.,]\d{2})?$/.test(amount)) normalized = amount.replace(',', '.');
      else if (/^\d{1,3}(?:\.\d{3})+,\d{2}$/.test(amount)) normalized = amount.replace(/\./g, '').replace(',', '.');
      else if (/^\d{1,3}(?:,\d{3})+\.\d{2}$/.test(amount)) normalized = amount.replace(/,/g, '');
      else return null;
      const cents = Math.round(Number(normalized) * 100);
      return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
    };
    const validateProductPrice = (payload, expected) => {
      if (!payload || typeof payload !== 'object') return null;
      if (String(payload.id) !== expected.productId) return null;
      if (payload.handle !== expected.handle) return null;
      if (!Array.isArray(payload.variants)) return null;
      const variants = payload.variants.filter(variant => String(variant?.id) === expected.variantId);
      if (variants.length !== 1) return null;
      if (variants[0].available !== true) return null;
      if (!Number.isSafeInteger(variants[0].price) || variants[0].price <= 0) return null;
      return variants[0].price;
    };
    const createReferencePriceSource = ({ origin, rootUrl, expectedCurrency, fetcher, catalog, handles }) => {
      const pageCache = new Map();
      const endpoint = suffix => {
        if (typeof rootUrl !== 'string' || !rootUrl.startsWith('/') || rootUrl.startsWith('//') || /[?#]/.test(rootUrl)) throw new Error('invalid_locale_root');
        const url = new URL(rootUrl.replace(/\/?$/, '/') + suffix, origin);
        if (url.origin !== origin) throw new Error('cross_origin_reference');
        return url.href;
      };
      const readJson = async url => {
        const response = await fetcher(url, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          redirect: 'error',
          headers: { Accept: 'application/json' }
        });
        const contentType = response.headers?.get('content-type') || '';
        const mediaType = contentType.split(';')[0].trim().toLowerCase();
        if (!response.ok) throw new Error('http_error');
        if (!['application/json', 'application/javascript', 'text/javascript'].includes(mediaType)) throw new Error('non_json');
        return response.json();
      };
      const getVariantPrice = async variantId => {
        if (expectedCurrency !== 'EUR') return null;
        const productId = catalog[variantId];
        const handle = handles[productId];
        if (!productId || typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
        try {
          if (!pageCache.has(handle)) pageCache.set(handle, readJson(endpoint('products/' + encodeURIComponent(handle) + '.js')));
          const payload = await pageCache.get(handle);
          return validateProductPrice(payload, { variantId, productId, handle });
        } catch (_) {
          return null;
        }
      };
      return { getVariantPrice };
    };
    const selectionSignature = snapshot => JSON.stringify({
      parentId: snapshot.parentId,
      currency: snapshot.currency,
      nativeSubtotal: snapshot.nativeSubtotal,
      nativeDiscount: snapshot.nativeDiscount,
      total: snapshot.total,
      rows: snapshot.rows.map(row => [row.variantId, row.productId, row.quantity, row.nativePrice, row.knownVariant, row.isDuo, row.sectionIndex]).sort((left, right) => left[0].localeCompare(right[0]))
    });
    const formulaPolicies = {
      '15686025478409': { choices: 1, percent: 0 },
      '15686025806089': { choices: 2, percent: 2 },
      '15686025871625': { choices: 3, percent: 3 },
      '15686026985737': { choices: 4, percent: 4 }
    };
    const adjustedDuoVariants = new Set(['57357251281161', '57357251707145', '57357251805449', '57357252329737']);
    const calculateComparison = ({ parentId, currency, rows, nativeSubtotal, nativeDiscount, total, references }) => {
      const policy = formulaPolicies[parentId];
      const unavailable = (reason, row = {}) => ({ state: 'unavailable', reason, variantId: row.variantId, sectionIndex: row.sectionIndex });
      if (!policy) return unavailable('unknown_parent');
      if (currency !== 'EUR') return unavailable('unsupported_currency');
      if (!rows.length) return { state: 'empty' };
      if (rows.length < policy.choices) return { state: 'incomplete' };
      if (rows.length !== policy.choices) return unavailable('row_count_mismatch');
      if (!Number.isSafeInteger(total) || total <= 0) return unavailable('invalid_native_total');
      const seen = new Set();
      const sections = new Set();
      let reference = 0;
      let publicSum = 0;
      let nativeSum = 0;
      let duoCount = 0;
      let duoAdjustment = 0;
      for (const row of rows) {
        if (!row.variantId || seen.has(row.variantId) || row.quantity !== 1 || !Number.isSafeInteger(row.nativePrice) || row.nativePrice <= 0) return unavailable('invalid_native_row', row);
        if (!Number.isInteger(row.sectionIndex) || row.sectionIndex < 0 || row.sectionIndex >= policy.choices || sections.has(row.sectionIndex)) return unavailable('invalid_section', row);
        if (!Number.isSafeInteger(row.publicPrice) || row.publicPrice <= 0) return unavailable('reference_price_missing', row);
        seen.add(row.variantId);
        sections.add(row.sectionIndex);
        publicSum += row.publicPrice;
        nativeSum += row.nativePrice;
        const duo = references[row.variantId];
        if (duo) {
          if (row.sectionIndex !== 0 || row.productId !== duo.productId || !Number.isSafeInteger(duo.shampooPrice) || duo.shampooPrice <= 0 || !Number.isSafeInteger(duo.conditionerPrice) || duo.conditionerPrice <= 0) return unavailable('duo_reference_invalid', row);
          reference += duo.shampooPrice + duo.conditionerPrice;
          duoCount += 1;
          if (policy.choices === 1 && adjustedDuoVariants.has(row.variantId)) duoAdjustment = 100;
        } else {
          if (row.isDuo || row.sectionIndex === 0 || !row.knownVariant) return unavailable('complement_identity_invalid', row);
          reference += row.publicPrice;
        }
        const allowedAdjustment = policy.choices === 1 && duo ? duoAdjustment : 0;
        if (row.nativePrice !== row.publicPrice - allowedAdjustment) return unavailable('native_public_price_variance', row);
      }
      if (![reference, publicSum, nativeSum].every(Number.isSafeInteger)) return unavailable('unsafe_price_sum');
      const expectedSubtotal = publicSum - duoAdjustment;
      const expectedTotal = expectedSubtotal - Math.floor(expectedSubtotal * policy.percent / 100);
      if (duoCount !== 1) return unavailable('duo_count_mismatch');
      if (total !== expectedTotal || nativeSum !== publicSum - duoAdjustment) return unavailable('native_total_variance');
      if (policy.percent > 0 && (nativeSubtotal !== nativeSum || nativeDiscount !== nativeSubtotal - total)) return unavailable('native_discount_variance');
      if (policy.percent === 0 && ((nativeSubtotal !== undefined && nativeSubtotal !== nativeSum) || (nativeDiscount !== undefined && nativeDiscount !== 0))) return unavailable('native_duo_subtotal_variance');
      const saving = reference - total;
      return { state: saving > 0 ? 'positive' : saving === 0 ? 'equal' : 'higher', reference, total, saving, nativeDiscount: publicSum - total };
    };
    const config = document.getElementById('lbb-kit-savings-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    let references = {};
    try {
      references = JSON.parse(document.getElementById('lbb-kit-savings-references').textContent);
    } catch (_) {}
    const duoProductIds = new Set(Object.values(references).map(duo => duo.productId));
    const complementVariants = {
      '43989447409929': '8096905986313',
      '56378008437001': '15406293516553',
      '56388292641033': '15409984504073',
      '56403367297289': '15413407056137',
      '57175839867145': '15413445329161',
      '56403674988809': '15413445329161',
      '57175830331657': '15413508866313',
      '56404346929417': '15413508866313',
      '57180580708617': '15618228453641',
      '57180580741385': '15618228486409',
      '44042099425545': '8112591733001',
      '44042130063625': '8112600842505',
      '44042149724425': '8112609296649',
      '56377335546121': '15406046642441',
      '56392896184585': '15412273414409',
      '56403268993289': '15413370224905',
      '56804217684233': '15488852689161',
      '57339197587721': '15677622845705',
      '57194115432713': '15624220901641',
      '57194106355977': '15624218706185'
    };
    const complementHandles = {
      '8096905986313': 'masque-inceller-250-ml-lana-brasiles-reconstructeur',
      '15406293516553': 'masque-skala-bomba-de-vitaminas-1kg-soin-pour-cheveux-secs',
      '15409984504073': 'skala-creme-traitement-2-en-1-1kg-mais-liso',
      '15413407056137': 'masque-pour-cheveux-afro-1kg-crespo-divino-skala',
      '15413445329161': 'masque-hydratant-tropical-coconut-lana-brasiles',
      '15413508866313': 'masque-reparateur-forest-tanino-lana-brasiles',
      '15618228453641': 'masque-blond-reverse-200g-lana-brasiles',
      '15618228486409': 'masque-glossy-reverse-200g-lana-brasiles',
      '8112591733001': 'huile-de-finition-inceller-lana-brasiles',
      '8112600842505': 'spray-thermo-protecteur-260-ml-lana-brasiles',
      '8112609296649': 'leave-in-inceller-200-ml-lana-brasiles',
      '15406046642441': 'creme-coiffante-sans-rincage-skala-bomba-vitaminas',
      '15412273414409': 'skala-leave-in-boucles-3-en-1-avec-protecteur-thermique',
      '15413370224905': 'skala-crespo-divino-3-en-1-leave-in-vegan',
      '15488852689161': 'brume-capillaire-rayhanete-de-lana-brasiles',
      '15677622845705': 'body-splash-nuvem-200-ml',
      '15624220901641': 'body-splash-cuide-se-bem-deleite-200-ml-o-boticario',
      '15624218706185': 'body-splash-nativa-spa-ameixa-negra-200-ml-o-boticario'
    };
    const duoHandles = {
      '8145878778121': 'kit-inceller-shampoing-apres-shampoing',
      '8146348278025': 'kit-tropical-coconut-shampooing-apres-shampoing',
      '8146694537481': 'kit-forest-tanino-shampooing-apres-shampooing-lana-brasiles',
      '15428664852745': 'skala-mais-liso-shampoing-apres-shampoing-anti-frizz',
      '15685082939657': 'kit-duo-crespo-divino-shampoing-apres-shampoing-2-325-ml',
      '15685082972425': 'kit-duo-bomba-vitaminas-shampoing-apres-shampoing-2-325-ml',
      '15685083070729': 'kit-duo-match-science-pre-e-pos-quimica-shampoing-apres-shampoing-300-ml-280-ml',
      '15685083103497': 'kit-duo-satine-lily-shampoing-apres-shampoing-2-250-ml'
    };
    const publicPrices = createReferencePriceSource({
      origin: window.location.origin,
      rootUrl: text.rootUrl,
      expectedCurrency: text.currency,
      fetcher: window.fetch.bind(window),
      catalog: { ...complementVariants, ...Object.fromEntries(Object.entries(references).map(([id, duo]) => [id, duo.productId])) },
      handles: { ...complementHandles, ...duoHandles }
    });
    let pending = false;
    let requestedSignature = '';
    let resolvedSignature = '';
    let resolvedResult = null;
    let formatter;
    try {
      formatter = new Intl.NumberFormat(text.locale || 'fr', { style: 'currency', currency: 'EUR' });
    } catch (_) {
      formatter = new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' });
    }
    const money = cents => formatter.format(cents / 100);
    const setText = (element, value) => {
      if (element.textContent !== value) element.textContent = value;
    };
    const setHidden = (element, hidden) => {
      if (element.hidden !== hidden) element.hidden = hidden;
    };
    const buildPanel = () => {
      const panel = document.createElement('section');
      panel.className = 'lbb-kit-savings';
      panel.setAttribute('aria-labelledby', 'lbb-kit-savings-title');
      const title = document.createElement('h4');
      title.id = 'lbb-kit-savings-title';
      title.textContent = text.title;
      const values = document.createElement('dl');
      values.dataset.savingsValues = '';
      for (const key of ['reference', 'total']) {
        const line = document.createElement('div');
        const label = document.createElement('dt');
        label.textContent = text[key];
        const value = document.createElement('dd');
        value.dataset.savingsValue = key;
        line.append(label, value);
        values.append(line);
      }
      const state = document.createElement('p');
      state.dataset.savingsState = '';
      state.setAttribute('role', 'status');
      state.setAttribute('aria-live', 'polite');
      state.setAttribute('aria-atomic', 'true');
      const basis = document.createElement('p');
      basis.dataset.savingsBasis = '';
      basis.textContent = text.basis;
      const explanation = document.createElement('p');
      explanation.dataset.savingsExplanation = '';
      panel.append(title, values, state, basis, explanation);
      return panel;
    };
    const readSnapshot = root => {
      const cards = Array.from(root.querySelectorAll('.product-card[data-product-id]'));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'), row => {
        const variantId = row.dataset.variantId;
        const matches = cards.filter(card => Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]')).some(control => control.dataset.variantId === variantId));
        const card = matches.length === 1 ? matches[0] : null;
        const productId = card ? card.dataset.productId : '';
        const section = card && card.closest('.individual-products-section');
        const quantityText = row.querySelector('.scpt-price-quantity')?.textContent.trim() || '';
        return {
          variantId,
          productId,
          quantity: /^\d+$/.test(quantityText) ? Number(quantityText) : null,
          nativePrice: parseEurMoney(row.querySelector('.scpt-price-value')?.textContent),
          sectionIndex: section && /^\d+$/.test(section.dataset.sectionIndex) ? Number(section.dataset.sectionIndex) : null,
          knownVariant: isKnownComplementCard(card, variantId, complementVariants, complementHandles),
          isDuo: duoProductIds.has(productId) || section?.dataset.sectionIndex === '0'
        };
      });
      const readNativeValue = selector => {
        const nodes = Array.from(root.querySelectorAll(selector));
        if (!nodes.length) return undefined;
        const values = nodes.map(node => parseEurMoney(node.textContent));
        return values.every(value => value === values[0]) ? values[0] : null;
      };
      return {
        parentId: text.productId,
        currency: text.currency,
        rows,
        nativeSubtotal: readNativeValue('.side-cart-checkout-wrapper .subtotal-value'),
        nativeDiscount: readNativeValue('.side-cart-checkout-wrapper .discount-value'),
        total: readNativeValue('.side-cart-checkout-wrapper .total-value')
      };
    };
    const readComparison = root => {
      const snapshot = readSnapshot(root);
      if (!snapshot.rows.length) {
        requestedSignature = '';
        return { state: 'empty' };
      }
      const policy = formulaPolicies[snapshot.parentId];
      if (!policy || snapshot.currency !== 'EUR') {
        requestedSignature = '';
        return { state: 'unavailable', reason: !policy ? 'unknown_parent' : 'unsupported_currency' };
      }
      if (snapshot.rows.length < policy.choices) {
        requestedSignature = '';
        return { state: 'incomplete' };
      }
      if (snapshot.rows.length !== policy.choices) {
        requestedSignature = '';
        return { state: 'unavailable', reason: 'row_count_mismatch' };
      }
      const signature = selectionSignature(snapshot);
      if (resolvedSignature === signature) return resolvedResult;
      if (requestedSignature !== signature) {
        requestedSignature = signature;
        Promise.all(snapshot.rows.map(async row => ({ ...row, publicPrice: await publicPrices.getVariantPrice(row.variantId) }))).then(rows => {
          if (requestedSignature !== signature) return;
          const currentRoot = document.getElementById('bundlesuiteContainer');
          if (!currentRoot || selectionSignature(readSnapshot(currentRoot)) !== signature) {
            requestedSignature = '';
            return;
          }
          resolvedSignature = signature;
          resolvedResult = calculateComparison({ ...snapshot, rows, references });
          observer.disconnect();
          render();
          observe();
        });
      }
      return { state: 'loading' };
    };
    const render = () => {
      const root = document.getElementById('bundlesuiteContainer');
      const checkout = root && root.querySelector('.side-cart-checkout-wrapper');
      if (!checkout) return;
      let panel = root.querySelector('.lbb-kit-savings');
      if (!panel) {
        panel = buildPanel();
        checkout.before(panel);
      }
      const result = readComparison(root);
      const hasValues = ['positive', 'equal', 'higher'].includes(result.state);
      setHidden(panel.querySelector('[data-savings-values]'), !hasValues);
      setHidden(panel.querySelector('[data-savings-basis]'), !hasValues);
      setHidden(panel.querySelector('[data-savings-explanation]'), result.state !== 'positive');
      const positive = result.state === 'positive';
      if (panel.classList.contains('is-positive') !== positive) panel.classList.toggle('is-positive', positive);
      if (hasValues) {
        setText(panel.querySelector('[data-savings-value="reference"]'), money(result.reference));
        setText(panel.querySelector('[data-savings-value="total"]'), money(result.total));
        setText(panel.querySelector('[data-savings-explanation]'), result.nativeDiscount > 0 ? text.nativeDiscount : text.duo);
      }
      setText(panel.querySelector('[data-savings-state]'), positive ? text.saving + ' ' + money(result.saving) : text[result.state]);
    };
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        observer.disconnect();
        render();
        observe();
      });
    });
    const observe = () => observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-variant-id', 'data-product-id', 'data-product-handle', 'data-section-index']
    });
    render();
    observe();
  })();
  } catch(e) { console.error(e); }
})();

})();
